module.exports = __webpack_public_path__ + "img/card4.71354f91.png";